export const PASSWORD_MIN_LENGTH = 6;

export interface PasswordRule {
    id: string;
    label: string;
    test: (password: string) => boolean;
}

/** Espelha PasswordService.HasNonAlphanumeric (char.IsLetterOrDigit, Unicode-aware). */
function hasNonAlphanumeric(password: string): boolean {
    for (const ch of password) {
        if (!/\p{L}|\p{N}/u.test(ch)) {
            return true;
        }
    }
    return false;
}

export const PASSWORD_RULES: PasswordRule[] = [
    {
        id: 'length',
        label: `Mínimo de ${PASSWORD_MIN_LENGTH} caracteres`,
        test: (p) => p.length >= PASSWORD_MIN_LENGTH,
    },
    {
        id: 'lower',
        label: 'Pelo menos uma letra minúscula',
        test: (p) => /[a-z]/.test(p),
    },
    {
        id: 'upper',
        label: 'Pelo menos uma letra maiúscula',
        test: (p) => /[A-Z]/.test(p),
    },
    {
        id: 'digit',
        label: 'Pelo menos um número',
        test: (p) => /[0-9]/.test(p),
    },
    {
        id: 'special',
        label: 'Pelo menos um caractere especial',
        test: hasNonAlphanumeric,
    },
];

function validatePasswordPolicy(password: string): string[] {
    return PASSWORD_RULES.filter((rule) => !rule.test(password)).map((rule) => rule.label);
}

export function isPasswordPolicyValid(password: string): boolean {
    return validatePasswordPolicy(password).length === 0;
}
